import { z } from "zod/v4";
import { orderSchema } from "./domain.js";

// Output row shapes shared by the tool outputs (`bridge.ts`) and the review payloads (`review.ts`).
export const patientRow = z
  .object({
    patient_id: z.string(),
    encounter_id: z.string(),
    name: z.string(),
    time: z.string(),
    reason: z.string(),
    status: z.string(),
  })
  .strict();
export const chartFacts = z
  .object({
    patient_id: z.string(),
    name: z.string(),
    age: z.number(),
    sex: z.string(),
    dob: z.string(),
    allergy: z.string(),
    reaction: z.string(),
    problems: z.array(z.string()),
    vitals: z.object({ bp: z.string(), pulse: z.string(), weight: z.string(), bmi: z.string() }).strict(),
    social: z.string(),
    family: z.string(),
    surgery: z.string(),
  })
  .strict();
export const visitRow = z
  .object({
    id: z.string(),
    date: z.string(),
    date_ms: z.number().optional(),
    summary: z.string(),
    status: z.string(),
  })
  .strict();
export const medicationRow = z
  .object({
    id: z.string(),
    name: z.string(),
    strength: z.string(),
    directions: z.string(),
    date: z.string(),
    order: orderSchema.optional(),
  })
  .strict();
export const resultRow = z
  .object({
    id: z.string(),
    name: z.string(),
    kind: z.string(),
    value: z.string(),
    unit: z.string(),
    range: z.string(),
    flag: z.string(),
    date: z.string(),
    collected: z.string(),
    specimen: z.string(),
    previous: z.string().nullable(),
    detail: z.string(),
    reviewed: z.boolean().optional(),
  })
  .strict();
export const encounterRef = z.object({ id: z.string(), revision: z.number().int(), signed: z.boolean() }).strict();
/** Who a review is about: shown by the view next to the exact data, so the clinician sees whose chart they sign off. */
export const patientRef = z.object({ patient_id: z.string(), name: z.string(), dob: z.string() }).strict();
